import ni from '../data/node-index';

let indexAlias = {
  addAlias : node=>{
    let $alias = $('.ui-node-alias');
    if(!$alias.length){
      $alias = $(`<div class="ui-node-alias ui-modal">
        <span class="modal-close">&times;</span>
        <h5>Alias Name</h5>
        <input type="text" maxlength="25" placeholder="new alias name">
        <button type="button">add</button>
      </div>`);
      $alias.find('.modal-close').click(()=>{
        $alias.hide()
      });
      $('body').append($alias);
    }else{
      $alias.find('input[type=text]').val('');
      $alias.show();
    }
    $alias.find('button').off('click').on('click', ()=>{
      ($alias.find('input[type=text]').val() !== '') && ni.addAlias(node.name, $alias.find('input[type=text]').val());
      $alias.hide();
    });
  },
  aliasList : (name, list)=>{
    if(!list.length) return;
    let $aliases = $(`<ul class="ui-alias-list"></ul>`);
    list.forEach(x=>{
      $aliases.append(`<li>${x}</li>`);
    });
    $aliases.find('li').click(e=>{
      if(confirm('Delete Alias?')){
        ni.removeAlias(name, $(e.target).text());
        // $(e.target).remove();
      }
    })
    return $aliases;
  }
}

export default indexAlias;


// WEBPACK FOOTER //
// ./src/scripts/ui/index-alias.js